// From: https://github.com/peterpeterparker/web-social-share/blob/main/src/utils/utils.ts

export const isMobile = () => {
  return window?.matchMedia('(any-pointer:coarse)').matches;
};

export const staticOpenNewWindow = urlString => {
  if (window.self !== window.top) {
    window.open(urlString, '_blank');
  } else {
    window.open(urlString, '_self');
  }
};

export const shareEncodedUrl = socialShareUrl => {
  return encodeURIComponent(socialShareUrl || window.location.href);
};
